import React, { CSSProperties } from 'react';
import styles from './description-mini-input.module.scss';

interface IDescriptionMiniInputProps extends Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'onChange'
> {
  inputValue?: string;
  inputTitle?: string;
  inputPlaceholder?: string;
  style?: CSSProperties;
  onChange?: (value: string) => void;
}

export const DescriptionMiniInput: React.FC<IDescriptionMiniInputProps> = ({
  inputValue,
  style,
  inputTitle = 'Заголовок',
  inputPlaceholder = 'Пример',
  onChange,
  ...props
}) => {
  const renderInput = () => {
    return (
      <textarea
        maxLength={80}
        value={inputValue}
        className={styles.mini_input__input}
        placeholder={inputPlaceholder}
        onChange={(e) => {
          if (onChange) {
            onChange(e.target.value);
          }
        }}
        style={style}
        {...props}
      />
    );
  };

  return (
    <div className={styles.description_mini_input}>
      <div className={styles.mini_input__title}>{inputTitle}</div>
      {renderInput()}
    </div>
  );
};
